import { dispatchAction } from '@ardoq/rxbeach';
import { orgAdminsListActions } from './actions';
import { OpenDialogPayload } from './types';

const openDialog = (payload: OpenDialogPayload = {}) => {
  dispatchAction(orgAdminsListActions.openDialog(payload));
};

const closeDialog = () => {
  dispatchAction(orgAdminsListActions.closeDialog());
};

export const orgAdminsListCommands = {
  openDialog,
  closeDialog,
};
